export default __webpack_public_path__ + "static/media/SeedX-game-logo-564x186.37f2a3af.png";